import type { WizardFlowStepDefinition } from '@/modules/wizard/types/WizardFlowStepDefinition'
import type { WizardStepContext } from '@/modules/wizard/types/WizardStepContext'

/**
 * Evaluates a step's `if` / `unless` against the step context. See
 * {@link WizardFlowStepDefinition} for the semantics. Without a context (no
 * preconditions loaded) every step renders.
 */
export const shouldRenderStep = (
  step: WizardFlowStepDefinition,
  context: WizardStepContext | undefined,
): boolean => {
  if (!context) return true

  const ctx = context as unknown as Record<string, unknown>

  const ifResult = step.if
    ? step.if.every((condition) => ctx[condition] === true)
    : true

  const unlessResult = step.unless
    ? step.unless.some((condition) => ctx[condition] === false)
    : true

  return ifResult && unlessResult
}
